import { NavLink, Link } from "react-router-dom";
import {
  LayoutDashboard,
  Database,
  Users,
  Settings,
  HelpCircle,
  Bug,
  MessageSquare,
  Bot,
  Shield,
  Sparkles,
  Settings2,
  CreditCard,
} from "lucide-react";
import { useLocation } from "react-router-dom";
import intelligentiaLogo from "../../../images/intelligentia.jpg";
import clsx from "clsx";

const sections = [
  {
    label: "Overview",
    items: [
      { name: "Dashboard", href: "/admin/dashboard", icon: LayoutDashboard },
    ],
  },
  {
    label: "Content",
    items: [
      { name: "Records", href: "/admin/records", icon: Database },
      { name: "Conversations", href: "/admin/conversations", icon: MessageSquare },
      { name: "Agents", href: "/admin/agents", icon: Bot },
      { name: "Writing Assistant", href: "/admin/writing-assistant", icon: Sparkles },
    ],
  },
  {
    label: "Access & Billing",
    items: [
      { name: "Users", href: "/admin/users", icon: Users },
      { name: "Roles", href: "/admin/roles", icon: Shield },
      { name: "Plans", href: "/admin/plans", icon: Settings2 },
      { name: "Subscriptions", href: "/admin/subscriptions", icon: CreditCard },
    ],
  },
  {
    label: "System",
    items: [
      { name: "Debug", href: "/admin/debug", icon: Bug },
    ],
  },
];

export function Sidebar() {
  const location = useLocation();

  return (
    <div className="flex w-64 flex-col bg-gradient-to-b from-[#744796] to-[#48b2cd]">
      <div className="flex h-16 items-center gap-3 border-b border-white/10 px-6">
        <img
          src={intelligentiaLogo}
          alt="Intelligentia Logo"
          className="h-6 w-6 object-contain"
        />
        <Link
          to="/"
          className="text-md font-semibold text-white hover:text-blue-200 transition-colors"
        >
          Intelligentia Humana
        </Link>
      </div>

      <nav className="flex-1 overflow-y-auto px-3 py-4">
        {sections.map((section, idx) => (
          <div key={section.label} className={idx > 0 ? "mt-6" : ""}>
            <p className="mb-2 px-3 text-xs font-semibold uppercase tracking-wider text-white/50">
              {section.label}
            </p>
            <div className="space-y-1">
              {section.items.map((item) => (
                <NavLink
                  key={item.name}
                  to={item.href}
                  className={({ isActive }) =>
                    `flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
                      isActive
                        ? "bg-purple-500/20 text-white"
                        : "text-gray-300 hover:bg-purple-500/10 hover:text-white"
                    }`
                  }
                >
                  <item.icon className="h-5 w-5" />
                  {item.name}
                </NavLink>
              ))}
            </div>
          </div>
        ))}
      </nav>

      <div className="border-t border-white/10 p-4">
        <a
          href="#"
          className="flex items-center gap-3 text-sm font-medium text-gray-300 hover:text-white"
        >
          <HelpCircle className="h-5 w-5" />
          Help & Support
        </a>
      </div>
    </div>
  );
}
